import { Empty, Typography } from 'antd';
import emptyData from '../../../res/img/sin-tareas.png';
import './EmptyPlaceHolder.less';
/**
 * @component EmptyPlaceHolder.tsx
 * @description Empty state placeholder.
 * @return { Component }
 */

function EmptyPlaceHolder() {

  const { Title } = Typography;
  return (
    <Empty
      image={emptyData}
      imageStyle={{
        height: 448,
      }}
      style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', margin: 'auto'}}
      description={
        <div className="ml-empty__description">
          <Title level={3} className="ml-empty__text">
            No hay tareas para mostrar.
          </Title>
        </div>
      }
    >
    </Empty>
  );
}

export default EmptyPlaceHolder;
